<template>
    <b-autocomplete
      :rounded="rounded"
      field="name"
      v-model="symbol"
      :data="fundData"
      placeholder="Jump to values heatmap"
      icon="search"
      icon-pack="fas"
      clearable
      @select="option => (selectFund(option))"
      @input="loadResults"
      check-infinite-scroll
      :size="size || 'is-small'"
      max-height="350px"
    >
      <template slot-scope="props">
        <Flex class="breakSpaces flexColumn ">
            <strong>{{ props.option.ticker.symbol }}</strong>
            <small>{{ props.option.ticker.full_name }}</small>
            <p class="is-size-7 is-italic">Holdings as reported to the Securities and Exchange Commission on {{props.option.ticker.filing_date}}</p>
        </Flex>
    </template>
    <template slot="empty">No results found</template>
  </b-autocomplete>
</template>

<script>
import Flex from '@frontend/components/Flex.vue';

export default {
  data() {
    return {
      fundData: [],
      loading: false,
      symbol: '',
      abortControllers: [],
    };
  },
  components: {
    Flex,
  },
  props: {
    callback: Function,
    size: String,
    rounded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  },
  methods: {
    selectFund: function(option) {
      this.callback.call(this, option);
    },
    async loadResults() {
      this.abortControllers.forEach(controller => controller.abort());
      const abortController = new AbortController();
      this.abortControllers.push(abortController);
      this.loading = true;
      try {
        const data = await fetch(`/api/v1/explore/funds/?search=${this.symbol}`, { signal: abortController.signal });
        const jsonData = await data.json();
        this.fundData = jsonData.funds;
      } catch (e) {
        if (e.name === 'AbortError') {
          console.log('aborted');
        } else {
          console.log(e);
        }
      }
      this.loading = false;
    },
  },
};
</script>
